import React, { PropTypes } from 'react';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import constants from "../../../common/constants";

const styles = {
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 100,
  },
};

const UserListRow = ({ user, roles, rowStyles, onEdit, onDelete }) => {

  return (
    <TableRow>
      {/*<TableRowColumn style={rowStyles.column.photo}>*/}
      {/*{*/}
      {/*_.get(user, 'photo.url') &&*/}
      {/*<img className="user-image" src={_.get(user, 'photo.url')} />*/}
      {/*}*/}
      {/*</TableRowColumn>*/}

      <TableRowColumn style={rowStyles.column.loginId}>
        {user.loginId}
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.name}>
        {user.name}
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.role}>
        {_.get(_.find(roles, { _id: user.role }), 'name', '')}
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.status}>
        {_.get(_.find(constants.statuses, { value: user.status }), 'text', '')}
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.button}>
        <RaisedButton
          label="修改"
          primary={true}
          onClick={onEdit.bind(this, user._id)}
        />
        <RaisedButton
          label="刪除"
          secondary={true}
          style={{
            marginLeft: 10,
          }}
          onClick={onDelete.bind(this, user._id)} />
      </TableRowColumn>
    </TableRow>
  );
};

UserListRow.propTypes = {
  user: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
  rowStyles: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default UserListRow;



// WEBPACK FOOTER //
// client/adminPanel/panel/users/UserListRow.js